// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R

import styles from './index.module.scss';
import { InfoBlock } from 'components/molecules/MyPage/InfoBlock';
import { Field } from 'components/molecules/MyPage/Field';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectUser } from 'redux/slices/userSlice';
import { OperatorType } from 'util/Enums';
import { useMypageContactInfo } from 'util/hooks/useMypageContactInfo';
import { MyPageType } from 'types/mypage';
import { useMemo } from 'react';
import { REGEX_OBJECT } from 'util/ConstantValues';

export const CompressionRecycleAdminOperator = () => {
  const { t } = useTranslation();
  const user = useSelector(selectUser);
  const hasValidUser = !!user.userId && !!user.role;

  const mypageType =
    user.operatorType === OperatorType.Compressions
      ? MyPageType.CompressionAdminOperator
      : MyPageType.RecycleAdminOperator;

  const myPage = useMypageContactInfo<typeof mypageType>({
    myPageType: mypageType,
    enabled: hasValidUser,
  });

  const siteCount = useMemo(() => {
    return myPage.data?.siteCount ?? 0;
  }, [myPage.data?.siteCount]);

  return (
    <div className={styles.mypage}>
      <div className={styles.generalInfo}>
        <InfoBlock
          className={styles.accountInfo}
          title={t('my_page.account_info.title')}
        >
          <div className={styles.col}>
            <Field
              label={t('my_page.account_info.account_category')}
              value={t('my_page.account_info.compression_or_recycle')}
            />
            <Field
              label={t('my_page.account_info.account_permissions')}
              value={t('my_page.account_info.admin_operator')}
            />
          </div>
        </InfoBlock>
        <InfoBlock
          className={styles.masterInfo}
          title={t(
            'my_page.compression_recycle_admin_operator.master_info.title'
          )}
        >
          <div className={styles.grid}>
            <Field
              label={t(
                'my_page.compression_recycle_admin_operator.master_info.company_name'
              )}
              value={myPage.data?.operatorName}
            />
            <Field
              label={t(
                'my_page.compression_recycle_admin_operator.master_info.headquarter_location'
              )}
              value={myPage.data?.address}
            />
            <div />
            <Field
              label={t(
                'my_page.compression_recycle_admin_operator.master_info.number_of_managed_site'
              )}
              value={`${siteCount} ${t(
                `common.${siteCount > 1 ? 'sites' : 'site'}`
              )}`}
            />
            <Field
              label={t(
                'my_page.compression_recycle_admin_operator.master_info.mail_address'
              )}
              value={myPage.data?.staffEmail}
              format="email"
              maxLength={100}
              onEdit={(value) =>
                myPage.handleChangeInfo({
                  staffEmail: value,
                  tel: myPage.data?.tel || undefined,
                })
              }
            />
            <Field
              label={t(
                'my_page.compression_recycle_admin_operator.master_info.phone_number'
              )}
              value={myPage.data?.tel}
              format="phone"
              regex={REGEX_OBJECT.number}
              maxLength={15}
              onEdit={(value) =>
                myPage.handleChangeInfo({
                  staffEmail: myPage.data?.staffEmail || undefined,
                  tel: value,
                })
              }
            />
          </div>
        </InfoBlock>
      </div>
    </div>
  );
};
